module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/kontakt.json
// module id = 256
// module chunks = 210605642136508